// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1DpLA","obliqueLineWrap":"membershipbadge_obliqueLineWrap__10jVT","obliqueLine":"membershipbadge_obliqueLine__3qghE"};